{"websiteLanguages":["he","en","ru"],"websiteLanguagesMapping":{"he":"Hebrew","en":"English","ru":"Russian"},"defaultWebsiteLanguage":"en"}